export enum OPERATIONAL_CURRENCY_SYMBOL_POSITION {
  LEFT = "LEFT",
  RIGHT = "RIGHT",
}

export interface OperationalCurrencyInterface {
  id: number;
  name: string;
  shortName: string;
  symbol: string;
  symbolPosition: OPERATIONAL_CURRENCY_SYMBOL_POSITION;
}
